import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import QuestionCircleFilledSvg from "@ant-design/icons-svg/es/asn/QuestionCircleFilled";
import AntdIcon from "../components/AntdIcon";
var QuestionCircleFilled = function QuestionCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QuestionCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  QuestionCircleFilled.displayName = 'QuestionCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(QuestionCircleFilled);